import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useSelector } from 'react-redux';
import UITourStep from 'ui-shepherd-react/tour/UITourStep';
import UIBadge from 'UIComponents/badge/UIBadge';
import UIButton from 'UIComponents/button/UIButton';
import UICloseButton from 'UIComponents/button/UICloseButton';
import UIFlex from 'UIComponents/layout/UIFlex';
import useOneClickPublishTour from '../../hooks/useOneClickPublishTour';
import { getIsBlogPost } from '../../redux/selectors/contentReadOnlyDataSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const OneClickPublishTourStep = ({
  children
}) => {
  const {
    finishOneClickPublishTour
  } = useOneClickPublishTour();
  const isBlogPost = useSelector(getIsBlogPost);
  return /*#__PURE__*/_jsx(UITourStep, {
    tourKey: "cms-editor-one-click-publish",
    stepKey: "oneClickPublishClicked",
    showSteps: false,
    placement: "bottom",
    width: 400,
    content: {
      header: /*#__PURE__*/_jsxs(UIFlex, {
        align: "center",
        children: [/*#__PURE__*/_jsx("h4", {
          className: "m-right-2",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "oneClickPublishTour.header.title"
          })
        }), /*#__PURE__*/_jsx(UIBadge, {
          use: "new",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "oneClickPublishTour.header.new"
          })
        }), /*#__PURE__*/_jsx(UICloseButton, {
          size: "medium",
          onClick: finishOneClickPublishTour
        })]
      }),
      body: /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: `oneClickPublishTour.body.${isBlogPost ? 'blog' : 'pages'}`
          })
        })
      }),
      footer: /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(UIButton, {
          size: "sm",
          use: "primary"
          // eslint-disable-next-line @typescript-eslint/no-misused-promises
          ,
          onClick: finishOneClickPublishTour,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "oneClickPublishTour.footer.dismiss"
          })
        })
      })
    },
    children: children
  });
};
export default OneClickPublishTourStep;